import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { withZippiaHistory } from 'hooks';

import { openSignUpModal } from '../../store/modals/actions';

import styles from './WhatIsZippia.module.css';

const propTypes = {
  zippiaHistory: PropTypes.any.isRequired,
  openSignUpModal: PropTypes.func.isRequired,
};

class WhatIsZippia extends Component {
  personalizedJobs = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { zippiaHistory, openSignUpModal } = this.props;

    const query = {
      survey: '030',
      survey_step: 'step1',
    };
    openSignUpModal({
      ...query,
      popupType: 'what-is-zippia',
    }).then(() => {
      zippiaHistory.pushQuery(query);
    });
  };

  render() {
    return (
      <section className={`section ${styles['what-zippia-sec']}`}>
        <div className="container">
          <div className={`${styles['sec-head']} col-lg-12 no-side-padding`}>
            <div className="cb-med blue-text text-uppercase no-side-padding col-lg-6 offset-lg-3">
              <h2 className="brandonH2">The information and tools to find your next job</h2>
            </div>
            <div className="no-side-padding col-lg-8 offset-lg-2">
              <p>
                We believe that every person should have access to the best information available to
                evaluate and choose a job. Other sites list jobs, but they don&apos;t care how it fits
                you and your longer term career. Zippia helps you find and pursue the job that&apos;s
                right for your career.
              </p>
            </div>
          </div>

          <div className={styles['sec-body']}>
            <div className="row">
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <span onClick={this.personalizedJobs}>
                      <div
                        className={`rounded-circle icon-icon-personalized ${styles['icon-personalized-bg']}`}
                      />
                    </span>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className={`semi-bold-font zippia-blue-text mt-3`}>
                      <span onClick={this.personalizedJobs}>Personalized Jobs</span>
                    </h3>
                    <p>
                      Get job recommendations based on your background, workplace preferences, and
                      career goals.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/company/">
                      <div
                        className={`rounded-circle icon-icon-company ${styles['icon-company-bg']}`}
                      />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3">
                      <a href="/company/">Company Insights</a>
                    </h3>
                    <p>See if the company culture matches you.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/careers/">
                      <div className={`rounded-circle icon-icon-job ${styles['icon-job-bg']}`} />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3">
                      <a href="/careers/">Job Insights</a>
                    </h3>
                    <p>
                      Discover new career options based on your skill set, including salaries, job
                      responsibilities, and more.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className={styles['col-unit']}>
                  <div className={styles['unit-head']}>
                    <a href="/colleges-and-majors/">
                      <div
                        className={`rounded-circle icon-icon-careerpaths ${styles['icon-careerpaths-bg']}`}
                      />
                    </a>
                  </div>
                  <div className={styles['unit-body']}>
                    <h3 className="semi-bold-font zippia-blue-text mt-3">
                      <a href="/colleges-and-majors/">Career Paths</a>
                    </h3>
                    <p>
                      Discover new career options based on people with similar skill sets, salaries
                      and job responsibilities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

WhatIsZippia.propTypes = propTypes;

const mapDispatchToProps = {
  openSignUpModal,
};

export default withZippiaHistory(
  connect(
    ({ locals, modals }) => ({
      locals,
      modals,
    }),
    mapDispatchToProps
  )(WhatIsZippia)
);
